import { useContext, useCallback } from "react";

import Swal from "sweetalert2";
import { useHistory } from "react-router";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  createOrigem,
  updateOrigem,
  // eslint-disable-next-line
  deleteOrigem, //função será utilizada quando ativar opção de excluir intermediador
  listOrigem,
} from "../../../../repository/ERP/vendas/OrigemService";
import { findEstoque } from "../../../../repository/components/estoque/EstoqueService";
import { findTabelaPrecos } from "../../../../repository/ERP/prouser/TabelaPrecosService";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import { IntermediadorContext } from "../contexts/IntermediadorContext";
import { findIntermediadorByCnpj } from "../../../../repositories/qerpapi/erp/vendas/v1/OrigemRepository";
import { findByCNPJ } from "../../../../repository/services/BigDataService";

export default function useIntermediadorController() {
  const { queryParams } = useContext(QueryParamsContext);
  const { push, go } = useHistory();

  const {
    setLoading,
    setGeralErrors,
    intermediadorIdNew,
    intermediadorCnpjNew,
    setIntermediadorCnpjNew,
    intermediadorAtivoNew,
    isIntermediadorNew,
    intermediadorRazaoNew,
    setIntermediadorRazaoNew,
    identificadorUsuarioNew,
    intermediadorDescricaoNew,
    estoquesIdNew,

    //Funcoes
    setExpanded,
  } = useContext(IntermediadorContext);

  const handleBackSubmit = () => {
    push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj);
  };

  const handleCancelSubmit = () => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja cancelar?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj);
      }
    });
  };

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const listTabelaPrecoData = useCallback(async () => {
    let retorno = await findTabelaPrecos(
      queryParams.empresa_cnpj.replace(/\D/g, "")
    );
    let TabelaPrecos = retorno.data ? retorno.data : null;
    return TabelaPrecos;
  }, [queryParams.empresa_cnpj]);

  const listLocaisEstoque = useCallback(async () => {
    let retorno = await findEstoque(
      queryParams.empresa_cnpj.replace(/\D/g, "")
    );
    let LocaisEstoque = retorno && retorno.data ? retorno.data : null;
    return LocaisEstoque;
  }, [queryParams.empresa_cnpj]);

  const handleNumInscricao = (inputValue) => {
    const getData = async () => {
      try {
        setLoading(true);
        const intermediaryExists = await findIntermediadorByCnpj(
          queryParams.empresa_cnpj,
          inputValue.replace(/[^0-9]+/g, "")
        );
        if (intermediaryExists.success && intermediaryExists.data.length) {
          setIntermediadorCnpjNew("");
          setLoading(false);
          return notify("Já existe um Intermediador com esse Nº de inscrição.");
        }

        const response = await findByCNPJ(inputValue);
        const responseData = response?.data;

        if (
          response.success &&
          responseData.statusCode === 200 &&
          responseData.data
        )
          return setIntermediadorRazaoNew(
            responseData.data.corporate_name || ""
          );

        notify(
          "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
        );
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  };

  const handleSubmit = async (again) => {
    setLoading(true);

    const required = [
      { value: intermediadorCnpjNew, key: "intermediadorCnpjNew" },
      { value: intermediadorRazaoNew, key: "intermediadorRazaoNew" },
      { value: identificadorUsuarioNew, key: "identificadorUsuarioNew" },
      { value: intermediadorDescricaoNew, key: "intermediadorDescricaoNew" },
    ];

    let resultValidation = validNotNull(required);

    if (resultValidation.error) {
      setGeralErrors(resultValidation.errorsValidation);
      setLoading(false);
      return notify("Verifique se os campos obrigatórios estão preenchidos.");
    }

    const checkDescricaoIntermediadores = await listOrigem(
      queryParams.empresa_cnpj,
      "descricao",
      intermediadorDescricaoNew
    );

    if (
      checkDescricaoIntermediadores.data &&
      checkDescricaoIntermediadores.data.find(
        (current) => current.id !== intermediadorIdNew
      )
    ) {
      notify("Descrição de intermediador já utilizada.");
      setLoading(false);
      return;
    }

    const storeData = {
      origem: {
        ativo: intermediadorAtivoNew ? 1 : 0,
        intermediador: isIntermediadorNew ? 1 : 0,
        razao: intermediadorRazaoNew.slice(0, 60),
        cnpj: intermediadorCnpjNew,
        identificador_usuario: identificadorUsuarioNew.slice(0, 100),
        descricao: intermediadorDescricaoNew.slice(0, 255),
        status: 0,
        locaisEstoques: estoquesIdNew.map((localEstoque) => localEstoque.id),
      },
    };

    var returnApi;
    if (!intermediadorIdNew)
      returnApi = await createOrigem(queryParams.empresa_cnpj, storeData);
    else
      returnApi = await updateOrigem(
        intermediadorIdNew,
        queryParams.empresa_cnpj,
        storeData
      );

    setLoading(false);

    if (returnApi.success) {
      if (again) {
        push("cadastro?empresa_cnpj=" + queryParams.empresa_cnpj, null);
        go(0);
        return notify("Intermediador cadastrado com sucesso", true, "success");
      } else {
        push("listagem?empresa_cnpj=" + queryParams.empresa_cnpj);
        return notify("Intermediador cadastrado com sucesso", true, "success");
      }
    } else return notify("Falha ao Cadastrar/Atualizar Intermediador");
  };

  return {
    listTabelaPrecoData,
    listLocaisEstoque,
    handleNumInscricao,
    handleSubmit,
    handleBackSubmit,
    handleCancelSubmit,
    handleChangeOpenAcordion,
  };
}
